import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SIDE_OPTIONS, Side } from '@/pages/instruments/new-instrument/constants/sides'

export interface SideFieldProps {}

export const SideField: React.FC<SideFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ side: Side }>()

  return (
    <FormField
      name="side"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Side</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'flex flex-1 min-w-auto! w-full'}
              value={value?.toString()}
              onValueChange={(value) => setValue('side', value as Side, { shouldValidate: true })}
              placeholder={'Choose a side'}
              options={SIDE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
